export default __webpack_public_path__ + "static/media/example6.5f6780f8.svg";